import { render, staticRenderFns } from "./SnoozeNotificationsTable.vue?vue&type=template&id=46afc69a&scoped=true&lang=pug"
import script from "./SnoozeNotificationsTable.vue?vue&type=script&lang=js"
export * from "./SnoozeNotificationsTable.vue?vue&type=script&lang=js"
import style0 from "./SnoozeNotificationsTable.vue?vue&type=style&index=0&id=46afc69a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46afc69a",
  null
  
)

export default component.exports